import nextId from '../../utils/nextId';
import {
  ADDEDTOCART,
  DECREASEFROMCART,
  INCREASEFROMCART,
  REMOVECART,
} from './actionTypes';
import initialState from './initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDEDTOCART:
      // checking if the product is already added to cart or not
      const alreadyAdded = state.find(
        (cartItem) => cartItem.productId === action.payload.id
      );

      // if product is already added, increase qunatity
      if (alreadyAdded) {
        return state.map((cartItem) => {
          if (cartItem.productId === alreadyAdded.productId) {
            return {
              ...cartItem,
              quantity: cartItem.quantity + 1,
            };
          }

          return cartItem;
        });
      } else {
        // if product is not already added, add the product to cart
        return [
          ...state,
          {
            ...action.payload,
            productId: action.payload.id,
            id: nextId(state),
            quantity: 1,
          },
        ];
      }

    // increasing quantity of cart Item
    case INCREASEFROMCART:
      return state.map((cartItem) => {
        if (cartItem.id === action.payload) {
          return {
            ...cartItem,
            quantity: cartItem.quantity + 1,
          };
        }

        return cartItem;
      });

    // decreasing quantity of cart Item
    case DECREASEFROMCART:
      return state.map((cartItem) => {
        if (cartItem.id === action.payload) {
          return {
            ...cartItem,
            quantity: cartItem.quantity - 1,
          };
        }

        return cartItem;
      });

    // removing product from cart
    case REMOVECART:
      return state.filter((cartItem) => cartItem.id !== action.payload);
    default:
      return state;
  }
};

export default reducer;
